import cs from 'classnames';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ButtonProps } from 'react-bootstrap/Button';
import { FacebookLogo } from './FacebookLogo';
import styles from './FacebookSignInButton.module.scss';

export function FacebookSignInButton({
  className, ...props
} : ButtonProps) {
  return (
    <div className={styles.container}>
      <Button
        className={cs(styles.submitButton, className)}
        variant="default"
        type="submit"
        {...props}
      >
        <Row className={styles.content}>
          <Col xs="auto" className={styles.logoWrapper}>
            <FacebookLogo />
          </Col>
          <Col>
            Sign in with Facebook
          </Col>
        </Row>
      </Button>
    </div>
  );
}
